export default "__VITE_ASSET__Cah3or0F__";